import React from 'react';
import { Avatar, Tag } from 'antd';
import { TeamOutlined, CrownOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { getPlanetBackground } from '../../utils/planetBackgrounds';

const TeamCard = ({ team, userRole, isCaptain = false }) => {
  const navigate = useNavigate();
  
  // 角色标签颜色映射
  const roleColorMap = {
    captain: '#05042E',
    member: '#C1C1D4',
    admin: '#79C74F'
  };

  // 角色标签文本映射
  const roleTextMap = {
    captain: '队长',
    member: '成员',
    admin: '管理员'
  };

  const roleColor = roleColorMap[userRole] || '#C1C1D4';
  const roleText = roleTextMap[userRole] || '成员';

  // 获取星球背景图
  const planetBackground = getPlanetBackground(team.scene);

  // 处理卡片点击事件
  const handleCardClick = () => {
    // 跳转到团队详情页（工作台）
    navigate(`/workspace/${team.id}`);
  };

  return (
    <div 
      className="relative cursor-pointer transition-transform duration-200 hover:scale-105"
      onClick={handleCardClick}
    >
      {/* 左上角标签 */}
      <span className="absolute top-1 left-0 bg-black bg-opacity-50 text-white px-2 py-0.5 font-bold rounded-br-md text-xs z-20">
        燕缘 · 滴水湖站
      </span>
      {/* 团队头像区域 */}
      <img
        src={planetBackground}
        alt={team.scene || '团队星球背景'}
        className="relative"
        style={{
          display: 'block',
          width: 'auto',
          height: 'auto',
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    </div>
  );
};

export default TeamCard;
